import {ContentContainer} from '@coolcolduk/ui-mui';
import ErrorComponent from '../../components/ErrorComponent/ErrorComponent';
import PageHeader from '../../components/PageHeader';
import {PrivateRouteProps} from '../../config/routeType';
import useListExamModules from '../../hooks/examModules/useListExamModules';
import LoadingPage from '../other/LoadingPage';
import CoursesAvailable from './CoursesAvailable';
import CoursesSelected from './CoursesSelected';

/**
 * First page the user see in root. It shows a list of courses the user has selected and a list of available courses.
 * @param user - The user object
 * @returns
 */
export default function CoursesPage({user}: PrivateRouteProps) {
  const {examModules, loading: modulesLoading, error: modulesError} = useListExamModules();

  if (modulesLoading) {
    return <LoadingPage center minusAppBar />;
  }

  if (modulesError) {
    console.error('Failed to load exam modules:', modulesError);
    return (
      <ErrorComponent
        message={`Failed to load modules. Please try again.`}
        buttonText="Try again"
        handleClick={() => window.location.reload()}
      />
    );
  }

  return (
    <ContentContainer data-testid="courses-page">
      <PageHeader title="Courses" subtitle="Select your courses and start learning" />

      <CoursesSelected userModules={user.selectedModules || []} examModules={examModules} />

      {/* Available Modules Section */}
      <CoursesAvailable userModules={user.selectedModules || []} examModules={examModules} />
    </ContentContainer>
  );
}
